// projectService.js
import { collection, doc, onSnapshot } from 'firebase/firestore';
import { db } from './firebaseConfig';

// Function to fetch project data based on user role and project ID
export const fetchProjectData = (userRole, projectId, setRows) => {
  let unsubscribe;

  if (userRole === "User" && projectId) {
    // Fetch only the user's assigned site
    const siteDocRef = doc(db, "IndividualSites", projectId);
    unsubscribe = onSnapshot(siteDocRef, (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setRows([{
          id: docSnap.id,
          ...data,
          client: data.client || "Unknown",
        }]);
      } else {
        setRows([]);
        console.log("No document found for this project ID.");
      }
    });
  } else {
    // Fetch all sites for other roles
    const sitesCollectionRef = collection(db, "IndividualSites");
    unsubscribe = onSnapshot(sitesCollectionRef, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
        client: doc.data().client || "Unknown",
      }));
      setRows(data);
    });
  }

  return unsubscribe;
};
